/* ==========================================================================
   LoadingInformationRxjs > template
   ========================================================================== */

/* Import modules */
const { html } = require('common-tags');
const { addStyle, prepareDataConfig } = require('@bluekiri/alexandria/helpers/dataHelpers');

const Image = require('../image-rxjs/template');

const configuration = require('./client/js/config');

/**
 * Renders
 */
const renderImage = (data, context) => {
    if (!data) return '';

    return Image(
        addStyle(
            {
                ...data.image,
                resize: configuration().image.resize
            },
            [configuration().css.image]
        ),
        context
    );
};

/* Render title */
const renderTitle = title => {
    if (!title) return '';

    return html(`<p class='loading-information-rxjs__title'>${title}</p>`);
};

/* Render content */
const renderContent = description => {
    if (!description) return '';

    return html(`<p class='loading-information-rxjs__description'>${description}</p>`);
};

/* Render Message */
const renderMessage = message => {
    if (!message) return '';

    return html(`<p class='loading-information-rxjs__message'>${message}</p>`);
};

/**
 * LoadingInformationRxjs component template
 * @param {object} data Object containing the data model for this component.
 * @param {object} context The general context object.
 * @returns {object} Additional data to have available in the template
 */
module.exports = function LoadingInformationRxjs(data, context) {
    /* Data */
    const { config = {}, title = '', description = '', message = '', image = {} } = data;
    const { styles = [] } = config;

    const { dataType } = prepareDataConfig(config.data);

    return html(`
        <div class='${['loading-information-rxjs', ...styles].join(' ').trim('')}'
            data-component='${configuration().component}'
            ${dataType ? `data-type='${dataType}'` : ''}
            data-config='${JSON.stringify({
                hasImage: !!image,
                ...config
            })}'>
            <div class="loading-information-rxjs__wrapper">
                <div class="loading-information-rxjs__image">
                    ${renderImage(data, context)}
                </div>
                <div class="loading-information-rxjs__loader"></div>
                <div class="loading-information-rxjs__body">
                    ${renderTitle(title)}
                    ${renderContent(description)}
                    ${renderMessage(message)}
                </div>
            </div>
        </div>
    `);
};
